<template>
  <div class="h-full overflow-hidden">
    <el-table :data="suspiciousDepartureData" border stripe class="mt-20px" :height="tableHeight">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="单位" prop="orgName" show-overflow-tooltip></el-table-column>
      <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="最近入厂时间" prop="enter" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ dayjs(scope.row.enter).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="离厂时间" prop="leave" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ dayjs(scope.row.leave).format('YYYY-MM-DD') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="suspiciousDepartureTableSizeChange"
      @current-change="suspiciousDepartureableCurrentChange"
      :current-page.sync="suspiciousDeparturePageConfig.SkipCount"
      :page-size.sync="suspiciousDeparturePageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="suspiciousDeparturePageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
  </div>
</template>
<script>
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import { IOTGateAccessRecordApi } from '@wiz-api/iot-device-management'

const contractorPersonnelApi = new ContractorPersonnelApi()
const iotGateAccessRecordApi = new IOTGateAccessRecordApi()
export default {
  data() {
    return {
      contractorPersonnelsList: [],
      suspiciousDepartureData: [],
      suspiciousDeparturePageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 75px)'
    },
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
    orgName: {
      type: String,
      default: '',
    },
  },
  async created() {
    await this.getContractorPersonnelsList()
    await this.getData()
  },
  methods: {
    async getContractorPersonnelsList() {
      const [err, res] = await contractorPersonnelApi.contractorPersonnelNamesDto({
        contractorId: this.contractorId,
      })
      if (!err) {
        this.contractorPersonnelsList = res
      }
    },
    // 奖励考核信息页码改变
    suspiciousDepartureTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    suspiciousDepartureableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      const names = this.contractorPersonnelsList.map((item) => {
        return item.contractorPersonnelName
      })
      const [err, res] = await iotGateAccessRecordApi.getLeaveFactorySituation({
        body: {
          names,
          orgName: this.orgName,
          skipCount:
            (this.suspiciousDeparturePageConfig.SkipCount - 1) *
            this.suspiciousDeparturePageConfig.MaxResultCount,
          maxResultCount: this.suspiciousDeparturePageConfig.MaxResultCount,
        },
      })
      if (!err) {
        this.suspiciousDepartureData = res.items
        this.suspiciousDeparturePageConfig.total = res.totalCount
      }
    },
  },
}
</script>
